
export default function splitLines(text: string): string[] {
    let lines = text?.split('\n') || [];
    lines = lines.map(l => l.trim());

    const filteredLines = []
    for (const line of lines) {
        if (line === '' && (filteredLines.length === 0 || filteredLines[filteredLines.length - 1] !== '')) {
            continue;
        }
        filteredLines.push(line);
    }

    return filteredLines;
}
